import Button from 'components/Button';
import { Col } from 'react-bootstrap';
import styled from 'styled-components';

export const SButton = styled(Button)`
  background-color: ${props => props.theme.colors.accent};
  color: ${props => props.theme.colors.main};
  &:hover {
    background-color: ${props => props.theme.colors.accent};
    color: ${props => props.theme.colors.main};
  }
`;

export const SFormCol = styled(Col)`
  input,
  select,
  textarea {
    min-height: 60px;
    border-radius: 0px;
    border: 1px solid ${props => props.theme.colors.main};
    color: 1px solid ${props => props.theme.colors.main};

    &:focus {
      border: 1px solid ${props => props.theme.colors.accent};
      outline: none;
    }
  }
`;
